import { useTranslation } from 'react-i18next'

import { Separator } from '../../../../../components/app-layout/separator/separator'
import './work-exp-card.scss'

export type WorkExpProps = {
  title: string | null
  companyName: string | null
  location: string | null
  startYear: number | null
  endYear: number | null
  description: string | null
  experienceInMonths: number | null
  duration: string | null
  imageURL: string | null
}

export const WorkExperienceCard = ({
  title,
  companyName,
  location,
  startYear,
  endYear,
  description,
  experienceInMonths,
  duration,
  imageURL,
}: WorkExpProps) => {
  const { t } = useTranslation()
  return (
    <div className="WorkExperienceCard">
      {imageURL !== null && (
        <>
          <div className="WorkExperienceCard__imgContainer">
            <img src={imageURL} alt="" />
          </div>
          <Separator.Horizontal width={13} />
        </>
      )}
      <div className="WorkExperienceCard__info">
        {title !== null && <span className="WorkExperienceCard__info__title">{title}</span>}
        {companyName !== null && <span className="WorkExperienceCard__info__company">{companyName}</span>}
        {location !== null && <span className="WorkExperienceCard__info__location">{location}</span>}
        {(experienceInMonths !== null || (startYear !== null && endYear !== null)) && (
          <span className="WorkExperienceCard__info__time">
            {startYear === null && endYear === null
              ? t('applicant_details.years_of_experience', { count: Math.round((experienceInMonths as number) / 12) })
              : `${startYear} - ${endYear}`}
          </span>
        )}
        {duration !== null && <span className="WorkExperienceCard__info__time">{duration}</span>}
        <p className="WorkExperienceCard__info__description">{description}</p>
      </div>
    </div>
  )
}
